var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9663 16.84C35.1867 16.84 37.7974 14.2293 37.7974 11.0089C37.7974 7.78842 35.1867 5.17773 31.9663 5.17773C28.7458 5.17773 26.1351 7.78842 26.1351 11.0089C26.1351 14.2293 28.7458 16.84 31.9663 16.84Z",
    stroke: "white",
    strokeWidth: 2.91557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9663 42.22C35.1867 42.22 37.7974 39.6093 37.7974 36.3889C37.7974 33.1684 35.1867 30.5577 31.9663 30.5577C28.7458 30.5577 26.1351 33.1684 26.1351 36.3889C26.1351 39.6093 28.7458 42.22 31.9663 42.22Z",
    stroke: "white",
    strokeWidth: 2.91557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2052 29.4744C14.4256 29.4744 17.0363 26.8637 17.0363 23.6433C17.0363 20.4228 14.4256 17.8121 11.2052 17.8121C7.98471 17.8121 5.37402 20.4228 5.37402 23.6433C5.37402 26.8637 7.98471 29.4744 11.2052 29.4744Z",
    stroke: "white",
    strokeWidth: 2.91557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3339 27.6705C18.5324 28.1465 23.0282 29.8806 26.2563 32.9166M15.3339 19.8944C19.9695 18.8912 23.5528 17.3574 26.2563 14.0099",
    stroke: "white",
    strokeWidth: 2.91557
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.2c60dcecc8042fe28d812171776fafc9.svg";
export { ForwardRef as ReactComponent };